import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function ClosingSection() {
  return <section className="w-full bg-[#1e2a4a] py-24 px-6 text-[#faf6ef] text-center" data-id="element-19">
      <div className="max-w-[680px] mx-auto" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-21">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-12 text-[#c9a96e]" data-id="element-22">
            The Honest Truth
          </h2>

          <div className="space-y-8 text-xl md:text-2xl leading-relaxed font-light text-[#faf6ef]/90" data-id="element-23">
            <p data-id="element-24">The first few nights, your child may test harder.</p>

            <div className="space-y-2" data-id="element-25">
              <p data-id="element-26">That doesn't mean it's not working.</p>
              <p data-id="element-27">It usually means they noticed the loopholes closed.</p>
            </div>

            <div className="py-8" data-id="element-28">
              <p className="font-serif italic text-[#c9a96e]" data-id="element-29">
                This kit isn't about winning.
              </p>
              <p className="font-serif italic text-[#c9a96e] mt-2" data-id="element-30">
                It's about making bedtime uneventful—so your child can fall
                asleep, and you can stop spending your whole evening on "just
                one more thing."
              </p>
            </div>
          </div>

          <div className="mt-8 mb-12" data-id="element-31">
            <p className="text-xs text-[#6b7fa3] max-w-md mx-auto leading-relaxed" data-id="element-32">
              Educational resources only. Not medical advice. If you suspect a
              medical concern, consult a qualified professional.
            </p>
          </div>

          <div className="mt-12 bg-[#faf6ef]/5 p-8 rounded-2xl border border-[#c9a96e]/20 backdrop-blur-sm" data-id="element-33">
            <p className="text-xl font-serif mb-8 text-[#faf6ef]" data-id="element-34">
              If bedtime has become the part of parenting you dread…
              <br data-id="element-35" />
              <span className="text-[#c9a96e] font-bold mt-2 block" data-id="element-36">
                Start with a system you can repeat when you're exhausted.
              </span>
            </p>

            <a href="https://www.gemmamama.com/cart/45504434274443:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="group inline-flex items-center justify-center px-8 py-5 text-xl font-bold text-[#1e2a4a] transition-all duration-200 bg-[#c9a96e] rounded-full hover:bg-[#d4b67d] hover:scale-105 shadow-lg shadow-[#c9a96e]/20 w-full md:w-auto" data-id="element-37">
              Download & print tonight
              <ArrowRight className="ml-2 h-6 w-6 transition-transform group-hover:translate-x-1" data-id="element-38" />
            </a>

            <div className="mt-6 text-[#faf6ef]/70" data-id="element-39">
              <p className="font-medium" data-id="element-40">
                Get The Bedtime Pass + Boundary Script Kit (Ages 4–6)
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}